export type DownloadJob = {
  id: string;
  filename: string;
  progress: number | null;
  cancel(): void;
};

type Listener = () => void;

export type DownloadJobStore = {
  jobs: DownloadJob[];
  listeners: Set<Listener>;
};

const STORE_KEY = "__specsheetDownloadJobStore";

// One list for the toast and the download, including after a hot reload.
const root = globalThis as typeof globalThis & {
  [STORE_KEY]?: DownloadJobStore;
};

export const getDownloadJobStore = (): DownloadJobStore => {
  if (!root[STORE_KEY]) {
    root[STORE_KEY] = {
      jobs: [],
      listeners: new Set(),
    };
  }
  return root[STORE_KEY];
};

const emit = (): void => {
  for (const listener of getDownloadJobStore().listeners) {
    listener();
  }
};

export const subscribeDownloadJobs = (listener: Listener): (() => void) => {
  const { listeners } = getDownloadJobStore();
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const getDownloadJobs = (): DownloadJob[] => getDownloadJobStore().jobs;

export const beginDownloadJob = (
  filename: string,
  cancel: () => void
): {
  setProgress(progress: number | null): void;
  finish(): void;
} => {
  const store = getDownloadJobStore();
  const id = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  store.jobs = [...store.jobs, { id, filename, progress: 0, cancel }];
  emit();

  return {
    setProgress(progress) {
      const current = getDownloadJobStore();
      const index = current.jobs.findIndex((item) => item.id === id);
      if (index === -1 || current.jobs[index].progress === progress) {
        return;
      }
      const next = [...current.jobs];
      next[index] = { ...current.jobs[index], progress };
      current.jobs = next;
      emit();
    },
    finish() {
      const current = getDownloadJobStore();
      if (!current.jobs.some((item) => item.id === id)) {
        return;
      }
      current.jobs = current.jobs.filter((item) => item.id !== id);
      emit();
    },
  };
};
